/*jshint strict: true */
/* global jQuery, $*/

var Raven = require('raven-js') ;
var sentryDSN = $('meta[name=sentry-dsn]').attr('content');

var ravenOptions = {
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage'
  ],
  ignoreUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
  ]
};

if (sentryDSN.length) {
    Raven
      .config(sentryDSN, ravenOptions)
      .install();
}

window.Vue = require('vue');
window.Events = new Vue({});

window.Vue.component('grecaptcha', require('./components/RecaptchaV3.vue'));

const app = new Vue({
  el: '#vue-app',

  methods: {
    submitFromWithCaptcha(selector) {
      Events.$emit('gRecaptchaSubmit', selector);
    },

    printMenu() {
      window.print();
    },
  },
});

window.athHelper = function() {
    if (typeof Cookies === 'undefined') {
        return;
    }
    var athDisplay = Cookies.get('ath-display');
    if (typeof athDisplay === 'undefined') {
        athDisplay = 3;
    }
    else if (athDisplay === 'false') {
        return;
    }

    athDisplay--;
    if (athDisplay < 1) {
        addToHomescreen({maxDisplayCount: 1});
        athDisplay = false;
    }

    Cookies.set('ath-display', athDisplay, {expires: 365});
};

(function () {
    "use strict";

    $(document).ready(function () {
        $('.js-accept-cookie').on('click', function (e) {
            e.preventDefault();
            if (typeof Cookies === 'undefined') {
              return;
            }
            // Now we want to allow cookies
            Cookies.set('allow-cookies', true, {expires: 365});
            window.location.reload(false);
        });

        $(".newsPage img, .article-page img").each((index, img) => {
            let $img = $(img);
            if ($img.attr('width')) {
              $img.css('max-width', $img.attr('width') + 'px')
            }
  
            if ($img.attr('height')) {
              $img.css('max-height', $img.attr('height') + 'px')
            }
          });
    });

    $(window).on( "load", function() {
        if (typeof Cookies !== 'undefined') {
            if (Cookies.get('allow-cookies')) {
                athHelper();
            }
        }
    });
}());

// Javascript to make table created with tinyMCE responsive
$('.js-tinymce-table').wrap('<div class="table-responsive"></div>');

// Javascript to make media iFrame created with tinyMCE responsive
$('.js-tinymce-iframe').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/app.js